// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorServerError_root__JZirB","titlePrimary":"ErrorServerError_titlePrimary__2V1EI"};